import api from '@modules/store/common/api/index.api';
import type CommonState from '@modules/store/common/types/CommonState.entity';
import type Features from '@modules/store/common/types/Features.entity';
import type FeaturesState from '@modules/store/common/types/FeaturesState.entity';
import type FetchFeaturesConfig from '@modules/store/common/types/FetchFeaturesConfig.entity';
import { ActionTree } from 'vuex';

export const actions: ActionTree<FeaturesState, CommonState> = {
  fetchFeatures: async ({ commit }, featuresConfig: FetchFeaturesConfig) => {
    commit('common/staticData/setLoading', true, { root: true });
    commit('setLoading', true);

    new api().fetchFeatures(featuresConfig, (data: Features) => {
      if (data && data.regionToggles) {
        commit('setFeatures', data.regionToggles);
      }
      commit('common/staticData/setLoading', false, { root: true });
      commit('setLoading', false);
    });
  },
};
